export enum SupplementaryAmountType {
    Percentage = 1,
    Value = 2
}
